import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import styled from 'styled-components';
import { PrimarySmallBtn, SuccessButton } from 'components/button';
import { useMediaQuery } from 'react-responsive';
import { fetchGetScratchCard, getEncryptedUserId, getQueryParamsFromString, postSendSurvey } from '__utils/common-utils';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector, useDispatch } from 'react-redux';
import Footer from 'components/footer';
import { LayoutContext } from 'components/app-routes';
import { BoldText } from 'views/common-styled-components';
import { Row, Col } from 'antd';
import { COLOR } from 'constants/colors';
import ToggleSwitch from 'components/toggleSwitch';
import { fetchGetUserMandatesList } from './mandate.actions';
import { useDeepCompare } from '../../hooks/use-deep-memo';
import UserMandateSelector from './mandate.selector';
import moment from 'moment';
import CustomTag from 'components/tag';
import MandateCards from './mandate-cards';
import { getAgentCode } from '__utils/storage';
import EmptyActiveMandates from './empty-invalid-mandates';
import { FileEmptyIcon } from 'assets/icons/file-empty';
import { UploadIcon } from 'assets/icons/upload-icon';


const DesktopMandateContainer = styled.div`
    .greyHeader{
        background-color: ${COLOR.GRAY5};
        padding: 15px 15px 15px 30px;
        align-items: center;
        border-bottom: 0.5px solid ${COLOR.DISABLED_BTN};
    }
    .idText{
        font-size: 18px !important;
        font-weight: 500;
    }
    .amountText{
        font-size: 16px !important;
        font-weight: 500;import MandateCards from './mandate-cards';

    }
`
const Mandates: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [mandates, setMandates] = useState([]);
    const { userMandatesList } = propsToJS(useSelector(UserMandateSelector));
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { orderNo } = getQueryParamsFromString(window.location.search);

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Mandates' }
        })
        dispatch(fetchGetUserMandatesList());
        const stickerSent = window.localStorage.getItem("orderSticker" + orderNo);
        if (!stickerSent && getAgentCode() && orderNo) {
            getScratchCard();
        }
        orderNo && sendSurvey();
    }, []);

    useEffect(() => {
        setMandates(userMandatesList);
    }, [useDeepCompare(userMandatesList)]);

    const getMandateStatus = (status: string) => {
        switch (status) {
            case 'Processing':
                return status;
            case 'New Mandate':
                return 'Pending';
            case 'Approved':
                return status;
            case 'Rejected':
                return status;
        }
    }

    
    // starts variant color passes from here based on status of mandate
    const getvariantfromstatus = (status: string) => {
        switch (status) {
            case "Processing":
                return 'warning';
            case "New Mandate":
                return 'danger';
            case "Approved":
                return 'success';
            case "Rejected":
                return 'disabled';
        }
    }
    // ends
    
    //@purpose: get scratch card if oreder placed
    const getScratchCard = () => {
        fetchGetScratchCard({
            agentCode: getAgentCode(),
            eventKey: 'flyy_mfsale',
        }, `orderSticker${orderNo}`, 1)
    };

    //@purpose: CSAT survey send
    const sendSurvey = () => {
        postSendSurvey();
    };

    const filterActiveMandates = (showActive: boolean) => {
        if (showActive)
            setMandates(userMandatesList && userMandatesList.filter((mandate: any) => { return mandate.status === 'Approved' }));
        else (setMandates(userMandatesList))
    }

    const showSetupMandate = () => {
        Mixpanel.track(getEventName("setupmandate", "clicked", "mandates"));
        history.push(`/profile/mandates/setup-mandate?flowType=profile&ucc=${getEncryptedUserId()}`)
    }

    // upload pending mandates CTA click function
    const showPendingMandate = (mandate: any) => {
        Mixpanel.track(getEventName("pendingMandate", "clicked", "mandates"));
        history.push(`/profile/mandates/setup-mandate?flowType=profile&ucc=${getEncryptedUserId()}&mandateId=${window.btoa(mandate.bseMandateId)}&mandateLimit=${window.btoa(mandate.amount)}`)
    }
    // ends

    const filterMandateComponent = <p className='activeSwitch' > Show Active &nbsp; <ToggleSwitch onChange={(checked: boolean) => filterActiveMandates(checked)} /> </p>
    const setupMandateBtn = <SuccessButton onClick={showSetupMandate}>Setup New Mandate</SuccessButton>

    return <div>
        {
            userMandatesList?.length > 0 ?
                <div>
                    {
                        !isMobile &&
                        <DesktopMandateContainer>
                            <div>
                                <Row className='greyHeader'>
                                    <Col xs={20} >
                                        <BoldText>Mandates</BoldText>
                                    </Col>
                                    <Col xs={4}>
                                        {setupMandateBtn}
                                    </Col>
                                </Row>
                            </div>
                            <div className='mandateContent'>
                                <div className="mandateHead">
                                    <p>Mandate ID</p>
                                    <p>Start Date</p>
                                    <p>End Date</p>
                                    <p>Mandate Limit</p>
                                    <p>Status</p>
                                    {filterMandateComponent}
                                </div>
                                {mandates?.length > 0 ?
                                    mandates?.map((mandate: any, index: number) =>
                                        <span key={index}>
                                            <div className='mandateDetails'>
                                                <p className='f16'>{mandate.bseMandateId} <br/><span>{mandate.type === "X" ? "Physical Mandate": "E-Mandate" }</span></p>
                                                <p>{moment(mandate.startDate).format('DD MMMM YYYY')}</p>
                                                <p>{mandate?.endDate ? moment(mandate?.endDate)?.format('DD MMMM YYYY'):'N/A'}</p>
                                                <p className='f16'>&#8377; {mandate?.amount?.toLocaleString('en-IN')}</p>
                                                <p><CustomTag rounded variant={getvariantfromstatus(mandate?.status)} fontSize='16'>{getMandateStatus(mandate?.status)}</CustomTag> </p>
                                                { (mandate.status === 'New Mandate' && mandate.type === "X") ? <span className='greenBoldText mandateUploadAlign' onClick={()=> showPendingMandate(mandate)}><UploadIcon enabled={true}/> &nbsp; Upload Mandate Form</span> : null }
                                            </div>
                                        </span>) :
                                    <EmptyActiveMandates />
                                }
                            </div>

                        </DesktopMandateContainer>
                    }
                    {
                        isMobile && <div>
                            <div className='mobileToggle'>{filterMandateComponent}</div>
                            {mandates?.length > 0 ? <MandateCards mandatesList={mandates} /> : <EmptyActiveMandates />}
                            <br />
                            <Footer>
                                {setupMandateBtn}
                            </Footer>
                        </div>
                    }
                </div> :
                <section className="noMsgBoxInner accContent CurrentHolding">
                    <div className="noMsgBox">
                        <FileEmptyIcon />
                        <h2 className='emptyMandate'>You don't have any mandates.</h2>
                        <PrimarySmallBtn onClick={() => showSetupMandate() } style={{padding: '6px 40px'}}>Setup Mandate</PrimarySmallBtn>
                    </div>
                </section>
        }


    </div>;
}

export default Mandates;